import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getCustomerInfo } from '@kfc-global/react-shared/redux/Actions/OrderservAction';
import { addFavOrder } from '@kfc-global/react-shared/redux/Actions/OrderHistoryAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import Modal from 'molecules/Modal';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  toastifyFnWithImage,
  getValueOrDefaultObject,
  getTernaryValue,
  getSafeString,
  getValueOrDefaultArray,
  getAndCheck,
  getAndCheckIfOneTrue,
} from 'common/utilities/utils';
import AddEditOrderName from 'molecules/AddToFavourite/Presentation/AddEditOrderName';

const fetchCustomerInfo = (tenantId, customerId, phoneNumber, dispatch) => {
  if (tenantId) {
    const payload = {
      customerId,
      tenantId,
      phoneNumber: getSafeString(phoneNumber),
      updateUserData: true,
    };
    dispatch(getCustomerInfo(payload));
  }
};

const AddEditModalComponent = props => {
  const {
    isMobile,
    editItemId,
    setEditItemId,
    showOccassionModal,
    setOccassionModalOpen,
    cardInfo,
    toastmessage,
    hasEdit = false,
    occasionName,
    setOccasionName,
    isAddFavOrderBox,
    updateSetOrderDetails,
  } = props;
  const dispatch = useDispatch();
  const [occasionFavName, setOccasionFavName] = useState('');
  const [lastOccasionName, setLastOccasionName] = useState('');
  const [disaableButton, setDisableButton] = useState(true);
  const [occasionNameArr, setOccasionNameArr] = useState([]);
  const favoriteOrderData = useSelector(data => getValueOrDefaultArray(data.profileReducer?.favouriteOrders));
  const { id: customerId, phone: phoneNumber } = useSelector(data =>
    getValueOrDefaultObject(data.profileReducer?.basic),
  );
  const favouriteOrderRegex =  useSelector(data => getValueOrDefaultArray(data.tenantReducer?.favouriteOrderRegex));
  const { tenantId } = useSelector(data => getValueOrDefaultObject(data.tenantReducer));
  const [isInValid, setIsInValid] = useState(false);
  const [isNameExist, setIsNameExist] = useState(false);
  const { FavoriteActiveWhite } = IMAGE_PATH;

  const imageTemp = <ImageComponent srcFile={FavoriteActiveWhite} />;
  const toastMessage = translateWithI18Next(TRANSLATE_MAPPING_KEY.FAVORITE_ORDER_NAME_EDITED);
  const modalTitleUniqueId = getTernaryValue(hasEdit, 'occassion-modal', 'OccassionModal');
  const dataTestId = getTernaryValue(hasEdit, 'edit-modal', '');

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setLastOccasionName(occasionName);
    setOccasionFavName(occasionName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showOccassionModal]);

  useEffect(() => {
    if (!!occasionFavName && getAndCheck(!isInValid, !isNameExist)) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [occasionFavName, isInValid, isNameExist]);

  const setOccasionNameHandlerOrderHistory = (event, isEditOrderName) => {
    let favOrderName = event?.target?.value;
    const index = occasionNameArr?.indexOf(favOrderName?.toUpperCase());
    const valid = favouriteOrderRegex?.test(favOrderName);
    if (!valid) {
      setIsInValid(true);
    } else if (getAndCheck(valid, index >= 0)) {
      if (isEditOrderName) {
        setIsNameExist(false);
        setIsInValid(false);
      } else {
        setIsNameExist(true);
        setIsInValid(false);
      }
    } else {
      setIsInValid(false);
      setIsNameExist(false);
    }
    setOccasionName(event?.target?.value);
    setOccasionFavName(event?.target?.value);
  };

  const onClearTextHandler = () => {
    setOccasionName('');
    setOccasionFavName('');
    setIsNameExist(false);
    setIsInValid(false);
  };

  const updateFavouriteOrderHistory = () => {
    let occasionNameInput = occasionFavName?.trim();
    const index = occasionNameArr?.indexOf(occasionNameInput?.toUpperCase());
    const valid = favouriteOrderRegex?.test(occasionFavName);
    let occasionNameInputLength = occasionNameInput?.replace(/ /g, '').length;
    if (getAndCheckIfOneTrue(!valid, occasionNameInputLength === 0)) {
      setIsInValid(true);
    } else if (valid && index >= 0) {
      setIsNameExist(true);
      setIsInValid(false);
    } else {
      const { id } = cardInfo;
      dispatch(
        addFavOrder(
          {
            customerId,
            tenantId,
            phoneNumber: getSafeString(phoneNumber),
          },
          {
            orderId: id,
            name: occasionFavName,
          },
        ),
      );
      if (getAndCheck(showOccassionModal, updateSetOrderDetails)) {
        updateSetOrderDetails({ saveFavoriteSummarySucess: true });
      }
      cancelClickHandler();
      toastifyFnWithImage(toastmessage, imageTemp, 'favorites-added-toast');
      setTimeout(() => {
        toast.dismiss();
      }, 3000);
    }
  };

  const updateFavOrderName = () => {
    let occasionNameInput = occasionFavName?.trim();
    const index = occasionNameArr?.indexOf(occasionNameInput?.toUpperCase());
    const valid = favouriteOrderRegex?.test(occasionFavName);
    let occasionNameInputLength = occasionNameInput?.replace(/ /g, '').length;
    if (getAndCheckIfOneTrue(!valid, occasionNameInputLength === 0)) {
      setIsInValid(true);
    } else if (valid && index >= 0 && lastOccasionName !== occasionFavName) {
      setIsNameExist(true);
      setIsInValid(false);
    } else {
      const payload = { tenantId, customerId, phoneNumber: getSafeString(phoneNumber) };
      const postBody = { orderId: editItemId, name: occasionFavName };
      dispatch(addFavOrder(payload, postBody));
      setEditItemId('');
      cancelClickHandler();
      toastifyFnWithImage(toastMessage, imageTemp, 'favorites-added-toast');
      setTimeout(() => {
        toast.dismiss();
      }, 3000);
    }
  };

  const updateFavOrderNameHandler = getTernaryValue(hasEdit, updateFavOrderName, updateFavouriteOrderHistory);

  useEffect(() => {
    const occasionNameArray = [];
    favoriteOrderData?.map(item => occasionNameArray?.push(item?.name?.toUpperCase()?.trim()));
    setOccasionNameArr(occasionNameArray);
    if (editItemId) {
      setIsInValid(false);
      setIsNameExist(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editItemId]);

  const occasionsModalProps = {
    id: 'occassion-modal',
    role: 'dialog',
    modalTitleId: modalTitleUniqueId,
    show: showOccassionModal,
    classNames: `Base-modal ${getTernaryValue(isMobile, 'Mobile-occassion-modal', 'Occassion-modal')}`,
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: () => cancelClickHandler(),
    modalTitle: '',
    modalTitleRequired: false,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };

  const cancelClickHandlerOrderHistory = () => {
    setOccassionModalOpen(false);
  };

  const cancelClickHandlerFavOrder = () => {
    setIsNameExist(false);
    setIsInValid(false);
    setOccassionModalOpen(false);
  };

  const cancelClickHandler = getTernaryValue(hasEdit, cancelClickHandlerFavOrder, cancelClickHandlerOrderHistory);

  useEffect(() => {
    fetchCustomerInfo(tenantId, customerId, phoneNumber, dispatch);
  }, [dispatch, tenantId, customerId, phoneNumber]);

  return (
    <div className='account-order-desktop' id='favourite-orders-global'>
      <div className='sub-section sub-section-favourite'>
        <section>
          {
            <Modal {...occasionsModalProps}>
              <div className='OccassionModal add-occassion-global'>
                {
                  <AddEditOrderName
                    onCancel={cancelClickHandler}
                    setOccasionNameHandler={setOccasionNameHandlerOrderHistory}
                    updateFavouriteOrder={updateFavOrderNameHandler}
                    occasionName={occasionFavName}
                    isNameExist={isNameExist}
                    isInValid={isInValid}
                    onClearTextHandler={onClearTextHandler}
                    disaableButton={disaableButton}
                    isEditOrderName={hasEdit}
                    editFavHeading={hasEdit}
                    data-testid={dataTestId}
                    isAddFavOrderBox={isAddFavOrderBox}
                  />
                }
              </div>
            </Modal>
          }
        </section>
      </div>
    </div>
  );
};

export default AddEditModalComponent;
